import React, { useRef, useCallback, useState } from 'react';

type Props = {
  minWidth?: number;
  maxWidth?: number;
};

export const HorizontalResizableContainer: React.FC<Props> = ({ children, minWidth, maxWidth }) => {
  const resizeRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  const resize = useCallback(
    (e: MouseEvent) => {
      if (!resizeRef.current) {
        return;
      }
      const handleWidth = 2;

      let width = window.innerWidth - e.clientX - handleWidth;

      if (minWidth) {
        width = Math.max(minWidth, width);
      }
      if (maxWidth) {
        width = Math.min(maxWidth, width);
      }
      // stateで更新すると大量のレンダリングが発生してしまうため
      resizeRef.current.style.width = `${width}px`;
    },
    [minWidth, maxWidth]
  );

  const handleonDragStart = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!resizeRef.current) {
        return;
      }

      e.preventDefault();
      document.addEventListener('mousemove', resize);
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', resize);
      });
    },
    [resize]
  );

  return (
    <div ref={resizeRef} style={{ display: 'flex', width: `${minWidth}px`, minWidth: `${minWidth}px` }}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        onMouseDown={handleonDragStart}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: isHovered ? '4px' : '2px',
          backgroundColor: '#E0E0E0',
          cursor: 'col-resize',
          transition: 'width 0.2s'
        }}
      />
      {children}
    </div>
  );
};
